import React, { useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import Loader from '../Spinner';
import styles from './index.module.scss';
import makeIconName from '../../utils/makeIconName';
import makeBodyText from '../../utils/makeText';
const SPINNER_COLOR_NORMALIZER = {
    primaryGreen: 'white',
    primaryBlue: 'white',
    secondary: 'blue',
    outlineBlue: 'blue',
    outlineBlack: 'black'
};
const SPINNER_SIZES_NORMALIZER = {
    S: 'S',
    M: 'M',
    L: 'M'
};
const SIZES_NORMALIZER = {
    S: 'x32',
    M: 'x44',
    L: 'x56'
};
const Button = ({ iconOnly, isBold, isFullWidth, isUppercase, isLoading, isDisabled, label, iconName, type = 'primaryGreen', onClick, btnSize = 'L', ID, submit = false, href, hrefTarget }) => {
    const btnRef = useRef(null);
    const [btnWidth, setBtnWidth] = useState(null);
    useEffect(() => {
        if (isFullWidth || isLoading) {
            return;
        }
        const { width } = btnRef.current && btnRef.current.getBoundingClientRect();
        setBtnWidth(width);
    }, [label, isFullWidth, isLoading]);
    const _handleClick = (e) => {
        if (isLoading) {
            return;
        }
        onClick && onClick(e);
    };
    const classesLabel = classNames({
        [makeBodyText('XL')]: true,
        [styles.label]: true,
        [styles.withUppercase]: isUppercase
    });
    const text = React.createElement("span", { className: classesLabel }, isBold ? React.createElement("strong", null, label) : label);
    const content = isLoading ? (React.createElement(Loader, { color: SPINNER_COLOR_NORMALIZER[type], size: SPINNER_SIZES_NORMALIZER[btnSize] })) : (text);
    const wrapClasses = classNames({
        [styles.actionButton]: true,
        [styles[type]]: type,
        [styles.fullWidth]: isFullWidth,
        [styles.isLoading]: isLoading,
        [styles[SIZES_NORMALIZER[btnSize]]]: !!btnSize,
        [styles.withIcon]: iconOnly
    });
    const iconSizeClass = btnSize !== 'S' ? makeIconName(iconName, 'x24') : makeIconName(iconName, 'x16');
    const NodeType = href ? 'a' : 'button';
    return (React.createElement(NodeType, Object.assign({ id: ID, className: wrapClasses, onClick: _handleClick, disabled: isDisabled, ref: btnRef }, (href ?
        {
            href,
            target: hrefTarget || '_self'
        } :
        { type: submit ? 'submit' : 'button' }), (iconOnly ? { 'aria-label': iconName } : {}), (isLoading && !isFullWidth ? { style: { width: `${btnWidth}px` } } : {})), !isLoading && iconOnly ? React.createElement("i", { className: `${styles.icon} ${iconSizeClass}` }) : content));
};
export default Button;
